module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-8x9-bdf2241389f1a5260ae4a3ad1cb9c418.jpg";